export const GRADE_LIST = 'GRADE_LIST';
export const GRADE_LIST_SUCCESS = 'GRADE_LIST_SUCCESS';
export const GRADE_LIST_ERROR = 'GRADE_LIST_ERROR';


export const GRADE_UPDATE = 'GRADE_UPDATE';
export const GRADE_UPDATE_DETAILS = 'GRADE_UPDATE_DETAILS';
export const GRADE_UPDATE_SUCCESS = 'GRADE_UPDATE_SUCCESS';
export const GRADE_UPDATE_ERROR = 'GRADE_UPDATE_ERROR';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';